import * as types from './mutation-types'
import { fetchCommandes, renvoyerCommande } from '../../../api/commandes'

const getInitialState = () => {
  return {
    commandes: { total: 0, elements: {} },
    fetchingCommandes: false,
    messageCommande: null
  }
}

const state = { ...getInitialState() }

const mutations = {
  [types.SET_COMMANDES](state, commandes) {
    state.commandes = commandes
  },
  [types.FETCH_COMMANDES](state, fetching) {
    state.fetchingCommandes = fetching
  },
  [types.MESSAGE_COMMANDE](state, message) {
    state.messageCommande = message
  }
}

const actions = {
  async updateCommandes({ commit }, params) {
    commit(types.FETCH_COMMANDES, true)
    const commandes = await fetchCommandes(params)
      .catch((e) => {
        const empty = { total: 0, elements: {} }
        commit(types.SET_COMMANDES, empty)
        commit(types.FETCH_COMMANDES, false)
        commit(types.MESSAGE_COMMANDE, null)
        throw e
      })
    commit(types.SET_COMMANDES, commandes)
    commit(types.FETCH_COMMANDES, false)
    commit(types.MESSAGE_COMMANDE, null)
  },
  async renvoyerCommande({ commit }, id) {
    await renvoyerCommande(id)
    commit(types.MESSAGE_COMMANDE, 'La commande ' + id + ' a été ré-expedié')
  }
}

const getters = {
  commandes: state => state.commandes,
  fetchingCommandes: state => state.fetchingCommandes,
  messageCommande: state => state.messageCommande
}

export default { state, mutations, actions, getters }
